export default __webpack_public_path__ + "static/media/investing_pref_05.c51f8864.png";